import { store } from '@betacrew/jars-flux'
export const componentKey = "FormAttachment";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setShowAddAttachmentPopup: (state, action) => {
            state.showAddAttachmentPopup = action.payload;
        },
        setUploadedFile: (state, action) => {
            state.uploadedFile = action.payload;
        },
        setUploadedFileData: (state, action) => {
            state.uploadedFileData = action.payload;
        },
    }, 
    initialReducerState: {
        loadingState: false,
        showAddAttachmentPopup: false,
        uploadedFile: null,
        uploadedFilePath: null,
    }
});
export const {
    setLoadingState,
    setShowAddAttachmentPopup,
    setUploadedFile,
    setUploadedFileData
} = actions;